var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLayoutSpeakerview = function SvgLayoutSpeakerview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.143.286A6.857 6.857 0 0 0 .286 7.143v13.714a6.857 6.857 0 0 0 6.857 6.857h13.714a6.857 6.857 0 0 0 6.857-6.857V7.143A6.857 6.857 0 0 0 20.857.286H7.143ZM20.857 2.57h-2.286v4h6.822a4.572 4.572 0 0 0-4.536-4Zm4.572 6.286H18.57v4h6.857v-4Zm0 6.286H18.57v4h6.857v-4Zm-.036 6.285h-6.822v4h2.286a4.572 4.572 0 0 0 4.536-4ZM16.286 2.572H7.143A4.571 4.571 0 0 0 2.57 7.143v13.714a4.571 4.571 0 0 0 4.572 4.572h9.143V2.57Z",
    fill: "#73777A"
  })));
};
export default SvgLayoutSpeakerview;